import { TextField } from '@flex-design-system/fx';
import { EmailIcon } from '@flex-design-system/legacy-flex-icons';
import { Translation, useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import { isValidEmail } from '@flex-packages/validator';
import { Controller, useFormContext } from 'react-hook-form';

import type { JobDescriptionFormState } from '../models';

export function EmailField() {
  const { t } = useTranslation();
  const { control, clearErrors } = useFormContext<JobDescriptionFormState>();

  return (
    <Controller
      control={control}
      name="email"
      rules={{
        required: t(trans('recruiting.email.edit.helper.required')),
        validate: value => {
          if (!isValidEmail(value)) {
            return t(trans('recruiting.email.edit.helper.validate'));
          }

          return true;
        },
      }}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            onChange={e => {
              field.onChange(e);
              clearErrors('email');
            }}
            variant="solid"
            id="email"
            type="email"
            required
            label={
              <TextField.Label leftSlot={<EmailIcon />}>
                <Translation tKey={trans('recruiting.email')} />
              </TextField.Label>
            }
            placeholder={t(trans('recruiting.email.edit.placeholder'))}
            state={error !== undefined ? 'error' : 'default'}
            helperText={
              <TextField.HelperText>{error?.message}</TextField.HelperText>
            }
          />
        );
      }}
    />
  );
}
